export const SHOW_DIFFERENCE_OPTION_ID = 'showDifference';
export const SHOW_ALL_VALUES_OPTION_ID = 'showAllValues';
export const YOY_TABLE_SETTINGS = 'yoyTableSettings';
export const YOY_YEARS_SETTINGS = 'yoyYearsSettings';

export const yoyTableSettingsOptions = [
    { id: SHOW_DIFFERENCE_OPTION_ID, text: 'Show difference (delta)' },
    { id: SHOW_ALL_VALUES_OPTION_ID, text: 'Show all values' },
];
